module.exports = __webpack_public_path__ + "static/media/special-offer-right.7aeae36b.png";